module.exports = __webpack_public_path__ + "static/media/reco_4.de5783cf.jpg";